<template>
  <form @submit.prevent="updateUserLogo" id="signatureForm">
    <div v-if="isCodeLessThanADayOld" class="flex flex-align-center">
      <EuiIcon class='eui-u-mr-3' name='infosperso' size='small' color="primary"/>
      <p class="eui-u-text-blue-grey" v-html="$t('signworkflows.sign.signatureCode.receivedLessThan24hAgo')"></p>
    </div>
    <div class="flex flex-col mb-4" v-if="signDialogData.canSkectchSignature">
      <EuiHeading :level="4" bold class="mb-4">{{ $t('signworkflows.sign.signatureMode') }}</EuiHeading>
      <EuiRadio v-model="signDialogData.selectedSignatureMode" name="selectedSignatureMode" value="auto-generated" selected>{{ $t('signworkflows.sign.signatureMode.auto') }}</EuiRadio>
      <EuiRadio v-model="signDialogData.selectedSignatureMode" name="selectedSignatureMode" value="hand-made">{{ $t('signworkflows.sign.signatureMode.manual') }}</EuiRadio>
      <EuiRadio v-model="signDialogData.selectedSignatureMode" name="selectedSignatureMode" value="logo-file">{{ $t('signworkflows.sign.signatureMode.image') }}</EuiRadio>
    </div>
    <template v-if="signDialogData.canSkectchSignature">
      <!-- signature display mode -->
      <div class="es-sign-dialog__signContainer" style="margin-top: 34px" v-if="signDialogData.selectedSignatureMode === 'auto-generated'">
        <p class="es-sign-dialog__sign-text" v-if="signDialogData.certificate">
          {{ signDialogData.certificate.firstname }} {{ signDialogData.certificate.lastname }}
        </p>
        <canvas ref="signatureCanvas" id="signatureCanvas" height="100" width="1000">
        </canvas>
      </div>
      <div v-else-if="signDialogData.selectedSignatureMode === 'hand-made'">
        <div class="flex">
          <div class="align-middle flex-1">
            <p class="flex-1">{{ $t('signworkflows.sign.signatureMode.manual.text') }}</p>
          </div>
          <div>
            <EuiButton variant="text" color="primary" @click.prevent.native="$refs.signaturePad.undoSignature()">
              {{ $t('signworkflows.sign.signatureMode.manual.undo') }}
            </EuiButton>
            <EuiButton variant="text" color="primary" @click.prevent.native="$refs.signaturePad.clearSignature()">
              {{ $t('signworkflows.sign.signatureMode.manual.reset') }}
            </EuiButton>
          </div>
        </div>
        <VueSignaturePad
          class="es-sign-dialog__pad"
          height="100px"
          ref="signaturePad"
        />
      </div>
      <div v-else-if="signDialogData.selectedSignatureMode === 'logo-file'">
        <div class="flex">
          <div class="align-middle flex-1">
            <p class="flex-1">{{ $t('signworkflows.sign.signLoad') }}</p>
          </div>
          <input ref="signatureUploader"
                 style="display: none"
                 type="file"
                 accept="image/png, image/jpeg"
                 @click="resetSignatureUploader"
                 @change="handleUploadSignature($event.target.files[0])">
          <div v-if="signDialogData.signatureImage">
            <EuiButton variant="text" color="primary" @click.prevent="$refs.signatureUploader.click()">
              {{ $t('signworkflows.sign.replace') }}
            </EuiButton>
            <EuiButton variant="text" color="primary" @click.prevent="signDialogData.signatureImage = undefined">
              {{ $t('signworkflows.sign.signatureMode.manual.reset') }}
            </EuiButton>
          </div>
          <div v-else>
            <EuiButton @click.prevent="$refs.signatureUploader.click()" variant="text" color="primary">
              {{ $t('button.upload') }}
            </EuiButton>
          </div>
        </div>
        <div class="es-sign-dialog__signContainer" style="height: 98px; width: 100%;">
          <template v-if="signDialogData.signatureImage">
            <img alt="signature" style="max-width: 100%; max-height: 100%;" :src="`data:image/png;base64, ${signDialogData.signatureImage.fileContent}`"/>
          </template>
        </div>
      </div>
    </template>
    <Code v-if="displayCode" :signworkflows="signworkflows" :isUsbSignAvailable="isUsbSignAvailable"/>
  </form>
</template>

<script>
import VueSignaturePad from 'vue-signature-pad';
import { mapGetters, mapActions } from 'vuex';
import SignatoryApi from '../../../../../api/signatory';
import Code from './Code';

export default {
  name: 'Signature',
  inject: ['signDialogData'],
  components: {
    VueSignaturePad, Code,
  },
  props: {
    signworkflows: {
      type: Array,
      required: true,
    },
    displayCode: {
      type: Boolean,
      default: false,
    },
    isUsbSignAvailable: {
      type: Boolean,
    },
  },
  data() {
    return {
      retrieveIsVisible: false,
    };
  },
  watch: {
    'signDialogData.selectedSignatureMode': function(value) {
      if (value === 'hand-made') {
        this.$nextTick(() => {
          this.signDialogData.isSignaturePadVisible = true;
        });
      } else {
        this.signDialogData.isSignaturePadVisible = false;
      }
    },
    'signDialogData.signatureCode': function(value) {
      this.signDialogData.hasSignatureCode = value && value.length > 5;
    },
    retrieveIsVisible(value) {
      this.signDialogData.certificate = value === false ? 'sms' : this.signDialogData.certificate.signatureRetrieveMode;
    },
    options(value) {
      this.setSelectedSignatureMode(value);
    },
  },
  computed: {
    ...mapGetters({
      options: 'ModuleEdocSign/auth/options',
      user: 'ModuleEdocSign/auth/user',
      searchParams: 'ModuleEdocSign/parapheurs/searchParams',
    }),
    signerSignWithMandat() {
      if (this.options && this.options.signerSignWithMandat) {
        return this.options.signerSignWithMandat.value === '1' || this.options.signerSignWithMandat.value === true;
      }
      return false;
    },
    isCodeLessThanADayOld() {
      if (!this.signDialogData.lastCertificateGenerationDate) return false;

      const lastGenDate = new Date(this.signDialogData.lastCertificateGenerationDate);
      const yesterday = new Date();
      yesterday.setUTCDate(yesterday.getUTCDate() - 1);
      return lastGenDate >= yesterday;
    },
  },
  methods: {
    ...mapActions({
      pushAlert: 'application/pushAlert',
      updateUser: 'ModuleEdocSign/signatory/updateSignatory',
      startLoading: 'application/startLoading',
      finishLoading: 'application/finishLoading',
      getSignworkflows: 'ModuleEdocSign/parapheurs/getSignworkflows',
      sendSignature: 'ModuleEdocSign/parapheurs/sendSignature',
      getDocContent: 'ModuleEdocSign/parapheurs/getDocContent',
    }),
    resetSignatureUploader() {
      this.$refs.signatureUploader.value = '';
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.result);
      });
    },
    handleUploadSignature(file) {
      this.getBase64(file)
        .then((res) => {
          const id = this.$uuid.v4();
          const fileContent = res.split(';')[1].split(',')[1];
          this.signDialogData.signatureImage = {
            id,
            name: file.name,
            fileContent,
            extension: file.name.split('.').pop(),
          };
        });
    },
    getDrawnSign() {
      if (this.$refs.signaturePad.isEmpty()) {
        this.pushAlert({
          message: this.$i18n.t('signworkflows.sign.sketch.empty'),
          type: 'error',
        });
        return null;
      }
      const canvas = this.$refs.signaturePad._vnode.children[0].elm;
      const ctx = canvas.getContext('2d');
      const copy = document.createElement('canvas').getContext('2d');
      const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const l = pixels.data.length;
      let i;
      const bound = {
        top: null,
        left: null,
        right: null,
        bottom: null,
      };
      let x;
      let y;

      // Iterate over every pixel to find the highest
      // and where it ends on every axis ()
      for (i = 0; i < l; i += 4) {
        if (pixels.data[i + 3] !== 0) {
          x = (i / 4) % canvas.width;
          y = ~~((i / 4) / canvas.width);

          if (bound.top === null) {
            bound.top = y;
          }

          if (bound.left === null) {
            bound.left = x;
          } else if (x < bound.left) {
            bound.left = x;
          }

          if (bound.right === null) {
            bound.right = x;
          } else if (bound.right < x) {
            bound.right = x;
          }

          if (bound.bottom === null) {
            bound.bottom = y;
          } else if (bound.bottom < y) {
            bound.bottom = y;
          }
        }
      }

      // Calculate the height and width of the content
      const trimHeight = bound.bottom - bound.top;
      const trimWidth = bound.right - bound.left;
      const trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);
      copy.canvas.width = trimWidth;
      copy.canvas.height = trimHeight;
      copy.putImageData(trimmed, 0, 0);
      return copy.canvas.toDataURL('image/png').split(';')[1].split(',')[1];
    },
    getPngImage() {
      const scale = 4;
      const canvas = document.getElementById('signatureCanvas');
      const resizedCanvas = document.createElement('canvas');
      const resizedContext = resizedCanvas.getContext('2d');
      resizedCanvas.width = canvas.width * scale;
      resizedCanvas.height = canvas.height * scale;
      resizedContext.font = `italic ${36 * scale}px Dancing Script`;
      resizedContext.fillText(`${this.signDialogData.certificate.firstname} ${this.signDialogData.certificate.lastname} `, 10 * scale, 50 * scale);

      const pixels = resizedContext.getImageData(0, 0, resizedCanvas.width, resizedCanvas.height);
      const l = pixels.data.length;
      let i;
      const bound = {
        top: null,
        left: null,
        right: null,
        bottom: null,
      };
      let x;
      let y;

      // Iterate over every pixel to find the highest
      // and where it ends on every axis ()
      for (i = 0; i < l; i += 4) {
        if (pixels.data[i + 3] !== 0) {
          x = (i / 4) % resizedCanvas.width;
          y = ~~((i / 4) / resizedCanvas.width);

          if (bound.top === null) {
            bound.top = y;
          }

          if (bound.left === null) {
            bound.left = x;
          } else if (x < bound.left) {
            bound.left = x;
          }

          if (bound.right === null) {
            bound.right = x;
          } else if (bound.right < x) {
            bound.right = x;
          }

          if (bound.bottom === null) {
            bound.bottom = y;
          } else if (bound.bottom < y) {
            bound.bottom = y;
          }
        }
      }
      // Calculate the height and width of the content
      const trimHeight = bound.bottom - bound.top;
      const trimWidth = bound.right - bound.left;
      const trimmed = resizedContext.getImageData(bound.left, bound.top, trimWidth, trimHeight);
      resizedCanvas.width = trimWidth;
      resizedCanvas.height = trimHeight;
      resizedContext.putImageData(trimmed, 0, 0);
      const pngSignature = resizedCanvas.toDataURL('image/png').split(';')[1].split(',')[1];
      this.signDialogData.pngSignature = pngSignature;
      return pngSignature;
    },
    setSelectedSignatureMode(value) {
      if (value) {
        if (this.signDialogData.isSignatureCodeMandatory && value.electronicSignatureImageTypeUsedByDefault) {
          this.signDialogData.selectedSignatureMode = value.electronicSignatureImageTypeUsedByDefault.value;
          return value.electronicSignatureImageTypeUsedByDefault.value;
        }
        if (value.visaSignatureImageTypeUsedByDefault) {
          this.signDialogData.selectedSignatureMode = value.visaSignatureImageTypeUsedByDefault.value;
          return value.visaSignatureImageTypeUsedByDefault.value;
        }
        this.signDialogData.selectedSignatureMode = 'auto-generated';
        return 'auto-generated';
      }
    },
    async updateUserLogo() {
      const promise = new Promise((resolve, reject) => {
        if (this.signDialogData.canSkectchSignature) {
          if (this.signDialogData.selectedSignatureMode === 'auto-generated') {
            this.signDialogData.certificate.logo = this.getPngImage();
            SignatoryApi.updateSignatory(this.signDialogData.certificate)
              .then((response) => {
                if (response.status === 'success') {
                  resolve(response);
                }
                reject(response);
              });
          } else if (this.signDialogData.selectedSignatureMode === 'hand-made') {
            const res = this.getDrawnSign();
            if (res !== null) {
              this.signDialogData.certificate.logo = res;
              this.startLoading();
              this.updateUser(this.signDialogData.certificate)
                .then(() => {
                  setTimeout(() => {
                    this.finishLoading();
                  }, 3000);
                  resolve({});
                })
                .catch(() => {
                  this.finishLoading();
                });
            }
          } else if (this.signDialogData.selectedSignatureMode === 'logo-file') {
            if (this.signDialogData.signatureImage !== null) {
              this.signDialogData.certificate.logo = this.signDialogData.signatureImage.fileContent;
              this.startLoading();
              this.updateUser(this.signDialogData.certificate)
                .then(() => {
                  setTimeout(() => {
                    this.finishLoading();
                  }, 3000);
                  resolve({});
                })
                .catch(() => {
                  this.finishLoading();
                });
            }
          }
        } else {
          resolve({});
        }
      });
      const response = await promise;
      this.$emit('next');
      return response;
    },
    updateUserCertProps(certificate) {
      this.signDialogData.certificate = certificate;
    },
  },
  created() {
    this.setSelectedSignatureMode(this.options);
    this.signDialogData.hasSignatureCode = this.signDialogData.signatureCode && this.signDialogData.signatureCode.length > 5;
    this.signDialogData.agreement = false;
    this.signDialogData.signatureStatus = '';
    // this.signDialogData.getPngImage = this.getPngImage;
  },
};
</script>
